(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-lab"]) return;
  try {
    
  (() => {
    const rootSelector = "[data-main-product]";

    const number = (value, fallback = 0) => {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : fallback;
    };

    const clampQuantity = (value) => Math.min(12, Math.max(1, Math.round(number(value, 1))));

    function formatNumber(value, precision, thousands, decimal) {
      const fixed = (number(value) / 100).toFixed(precision);
      const [integer, fraction] = fixed.split(".");
      const grouped = integer.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return precision ? `${grouped}${decimal}${fraction}` : grouped;
    }

    function formatMoney(root, cents) {
      const format = root.dataset.moneyFormat || "";
      const placeholder = format.match(/\{\{\s*(\w+)\s*\}\}/);
      if (placeholder) {
        let amount;
        switch (placeholder[1]) {
          case "amount_no_decimals": amount = formatNumber(cents, 0, ",", "."); break;
          case "amount_with_comma_separator": amount = formatNumber(cents, 2, ".", ","); break;
          case "amount_no_decimals_with_comma_separator": amount = formatNumber(cents, 0, ".", ","); break;
          case "amount_with_space_separator": amount = formatNumber(cents, 2, " ", ","); break;
          case "amount_no_decimals_with_space_separator": amount = formatNumber(cents, 0, " ", ","); break;
          case "amount_with_apostrophe_separator": amount = formatNumber(cents, 2, "'", "."); break;
          default: amount = formatNumber(cents, 2, ",", ".");
        }
        return format.replace(placeholder[0], amount).trim();
      }

      try {
        return new Intl.NumberFormat(document.documentElement.lang || "nb-NO", {
          style: "currency",
          currency: root.dataset.currency || "NOK",
          maximumFractionDigits: 2,
        }).format(number(cents) / 100);
      } catch (_error) {
        return `${formatNumber(cents, 2, " ", ",")} kr`;
      }
    }

    function selectedVariantData(root) {
      const control = root.querySelector("[data-product-variant-select]");
      const source = control?.tagName === "SELECT" ? control.selectedOptions[0] : control;
      return {
        id: control?.value || "",
        price: number(source?.dataset.variantPrice),
        available: source?.dataset.variantAvailable === "true",
        requiresPlan: source?.dataset.variantRequiresPlan === "true",
      };
    }

    function activePanel(root, variantId) {
      return Array.from(root.querySelectorAll("[data-product-plan-panel]"))
        .find((panel) => panel.dataset.variantId === String(variantId));
    }

    function setStatus(root, message, state = "") {
      const status = root.querySelector("[data-product-status]");
      if (!status) return;
      status.textContent = message;
      if (state) status.dataset.state = state;
      else delete status.dataset.state;
    }

    function sync(root, { announce = false } = {}) {
      const variant = selectedVariantData(root);
      const panel = activePanel(root, variant.id);
      const oneTime = root.querySelector('[data-product-purchase-mode][value="one_time"]');
      const subscription = root.querySelector('[data-product-purchase-mode][value="subscription"]');
      const panelValid = panel?.dataset.planSetValid === "true";
      const requiredDiscount = number(root.dataset.requiredDiscount, 10);
      const foodInformationReady = root.dataset.foodInformationReady === "true";

      if (oneTime) oneTime.disabled = !foodInformationReady || !variant.available || variant.requiresPlan;
      if (subscription) subscription.disabled = !foodInformationReady || !variant.available || !panelValid;

      let mode = root.querySelector("[data-product-purchase-mode]:checked")?.value || "one_time";
      if (variant.requiresPlan) {
        if (subscription) subscription.checked = true;
        mode = "subscription";
      } else if (mode === "subscription" && !panelValid) {
        if (oneTime) oneTime.checked = true;
        mode = "one_time";
      }

      root.querySelectorAll("[data-product-plan-panel]").forEach((candidate) => {
        candidate.hidden = mode !== "subscription" || candidate !== panel;
      });

      let plan = mode === "subscription" ? panel?.querySelector("[data-product-plan-option]:checked") : null;
      if (mode === "subscription" && !plan) {
        plan = panel?.querySelector('[data-product-plan-option][data-plan-days="30"]') || panel?.querySelector("[data-product-plan-option]");
        if (plan) plan.checked = true;
      }

      const quantityInput = root.querySelector("[data-product-quantity]");
      const quantity = clampQuantity(quantityInput?.value);
      if (quantityInput) quantityInput.value = String(quantity);

      const planDiscount = number(plan?.dataset.planDiscount);
      const planValid = mode !== "subscription" || Boolean(panelValid && plan && planDiscount === requiredDiscount);
      const unitPrice = mode === "subscription" ? number(plan?.dataset.planPrice) : variant.price;
      const basePrice = mode === "subscription" ? number(plan?.dataset.planBasePrice) : variant.price;
      const totalPrice = unitPrice * quantity;
      const savings = Math.max(0, basePrice - unitPrice) * quantity;
      const purchasable = foodInformationReady && variant.available && planValid && (mode !== "one_time" || !variant.requiresPlan);

      const canonicalPlan = root.querySelector("[data-canonical-selling-plan]");
      if (canonicalPlan) {
        Array.from(canonicalPlan.options).forEach((option) => {
          option.disabled = option.value === "" ? variant.requiresPlan : option.dataset.variantId !== variant.id;
        });
        canonicalPlan.value = mode === "subscription" && plan ? plan.value : "";
      }

      const unitPriceTarget = root.querySelector("[data-product-unit-price]");
      const oneTimePrice = root.querySelector("[data-one-time-price]");
      const subscriptionPrice = root.querySelector("[data-subscription-price]");
      const totalLabel = root.querySelector("[data-product-total-label]");
      const total = root.querySelector("[data-product-total]");
      const savingsTarget = root.querySelector("[data-product-savings]");
      const stickyPrice = root.querySelector("[data-product-sticky-price]");
      const stickyNote = root.querySelector("[data-product-sticky-note]");

      if (unitPriceTarget) unitPriceTarget.textContent = formatMoney(root, unitPrice);
      if (oneTimePrice) oneTimePrice.textContent = formatMoney(root, variant.price);
      if (subscriptionPrice) subscriptionPrice.textContent = panelValid && plan ? formatMoney(root, number(plan.dataset.planPrice)) : "Må konfigureres";
      if (totalLabel) totalLabel.textContent = mode === "subscription" ? "Per levering" : "Totalt";
      if (total) total.textContent = formatMoney(root, totalPrice);
      if (savingsTarget) savingsTarget.textContent = mode === "subscription" && savings > 0 ? `Du sparer ${formatMoney(root, savings)}` : "";
      if (stickyPrice) stickyPrice.textContent = formatMoney(root, totalPrice);
      if (stickyNote) stickyNote.textContent = mode === "subscription" && plan ? `Abonnement · ${plan.dataset.planDays} dager · ${quantity} stk.` : `Engangskjøp · ${quantity} stk.`;

      const submitLabel = purchasable
        ? "Legg i kurv"
        : !foodInformationReady
          ? "Produktinformasjon må godkjennes"
          : variant.available
            ? "Abonnement må konfigureres"
            : "Utsolgt";
      root.querySelectorAll("[data-product-submit], [data-product-sticky-submit]").forEach((button) => {
        button.disabled = !purchasable;
      });
      root.querySelectorAll("[data-product-submit-label], [data-product-sticky-submit-label]").forEach((target) => {
        target.textContent = submitLabel;
      });

      if (announce) {
        if (!foodInformationReady) setStatus(root, "Kjøp åpnes når obligatorisk produktinformasjon er godkjent.", "error");
        else if (!planValid) setStatus(root, `Abonnement krever godkjente 30-, 60- og 90-dagersplaner med ${requiredDiscount} % rabatt.`, "error");
        else setStatus(root, mode === "subscription" ? `${quantity} stk. hver ${plan.dataset.planDays}. dag er valgt.` : `${quantity} stk. som engangskjøp er valgt.`);
      }

      return { purchasable };
    }

    function init(root) {
      if (!root || root.dataset.productReady === "true") return;
      root.dataset.productReady = "true";

      root.addEventListener("change", (event) => {
        if (event.target.matches("[data-product-variant-select], [data-product-purchase-mode], [data-product-plan-option], [data-product-quantity]")) {
          sync(root, { announce: true });
        }
      });

      root.addEventListener("input", (event) => {
        if (event.target.matches("[data-product-quantity]")) sync(root);
      });

      root.addEventListener("click", (event) => {
        const input = root.querySelector("[data-product-quantity]");
        if (!input) return;
        if (event.target.closest("[data-product-quantity-decrease]")) {
          input.value = String(clampQuantity(number(input.value, 1) - 1));
          sync(root, { announce: true });
        }
        if (event.target.closest("[data-product-quantity-increase]")) {
          input.value = String(clampQuantity(number(input.value, 1) + 1));
          sync(root, { announce: true });
        }
      });

      root.querySelector("[data-canonical-product-form]")?.addEventListener("submit", (event) => {
        const state = sync(root);
        if (!state.purchasable) {
          event.preventDefault();
          setStatus(root, "Kontroller kjøpsvalg, lagerstatus og abonnementsoppsett før du fortsetter.", "error");
          root.querySelector("[data-product-purchase-mode]:checked")?.focus();
        }
      });

      sync(root);
      root.classList.add("is-enhanced");
    }

    function initAll(container = document) {
      if (container.matches?.(rootSelector)) init(container);
      container.querySelectorAll(rootSelector).forEach(init);
    }

    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => initAll());
    else initAll();
    document.addEventListener("shopify:section:load", (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
